import HeroBanner from "../components/Manufacture/HeroBanner";
import FacilitySection from "../components/Manufacture/FacilitySection";
import ProcessSection from "../components/Manufacture/ProcessSection";
import QualitySection from "../components/Manufacture/QualitySection";
import StatsBar from "../components/StatsBar/StatsBar";
import CertificationsSection from "../components/Manufacture/CertificationsSection";
import CTABanner from "../components/Manufacture/CTABanner";
import CmsPageHero from "../components/CmsPageHero";

export default function Manufacturing() {
  return (
    <div className="bg-[#fcf9f2] min-h-screen flex flex-col">
      <main className="flex-1">
        <CmsPageHero slug="manufacturing"><HeroBanner /></CmsPageHero>
        <FacilitySection />
        <ProcessSection />
        <QualitySection />
        <StatsBar slug="manufacturing" />
        <CertificationsSection />
        <CTABanner slug="manufacturing" />
      </main>
    </div>
  );
}
